import { createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useSingleTrainingsState = createStateHook(
  AppStoreProvider,
  state => state.pages.singleTrainings
)
